import React from 'react';
import { useHistory, useParams } from 'react-router-dom';
import AdminLayout from '../../layouts/AdminLayout';
import ProphetChapterFormModal from './ProphetChapterFormModal';

export default function ProphetChapterFormPage() {
  const history = useHistory();
  const { prophetId, chapterId } = useParams();

  const handleClose = () => {
    history.push(`/prophets/${prophetId}/chapters`);
  };

  const handleSuccess = () => {
    history.push(`/prophets/${prophetId}/chapters`);
  };

  return (
    <AdminLayout title={chapterId ? 'Edit Chapter' : 'Add Chapter'}>
      <ProphetChapterFormModal
        open={true}
        prophetId={prophetId}
        chapterId={chapterId || null}
        onClose={handleClose}
        onSuccess={handleSuccess}
      />
    </AdminLayout>
  );
}
